import { CouponStatus } from "@nibfe/mkt-coupon-api";
import { ENibBiz } from "./interface";
import { _toPx } from "../utils/style";
export const imageList = {
    expandLogo: {
        one: 'https://p0.meituan.net/ingee/07a30744fe3439859f70d70c59b7649e8927.png',
        two: 'https://p0.meituan.net/ingee/c1230417171cb83a903775205e91559c6561.png',
        default: 'https://p0.meituan.net/ingee/cef9572c3cdf0a069037f87764ddd5e47815.png'
    },
    expandArrow: "https://p0.meituan.net/ingee/fb902402ce7531792233ea0ad60fdf4b1186.png"
};
export const errorMsg = '活动太火爆了，请刷新重试';
export const amountColorConfig = {
    hotel: "#E02020",
    default: "#FF4B10"
};
export const couponBtnConfig = {
    [CouponStatus.NotStart]: {
        btnText: '未开始',
        buttonType: 'primary',
        isDisable: true
    },
    [CouponStatus.Ended]: {
        btnText: '已结束',
        buttonType: 'weak',
        isDisable: true
    },
    [CouponStatus.Expired]: {
        btnText: '已过期',
        buttonType: 'weak',
        isDisable: true
    },
    [CouponStatus.SoldOut]: {
        btnText: '已抢光',
        buttonType: 'weak',
        isDisable: true
    },
    [CouponStatus.Claimed]: {
        btnText: '已领取',
        buttonType: 'weak',
        isDisable: false
    },
    [CouponStatus.Used]: {
        btnText: '已使用',
        buttonType: 'weak',
        isDisable: true
    },
    [CouponStatus.ToUse]: {
        btnText: '去使用',
        buttonType: 'plain',
        isDisable: false
    },
    [CouponStatus.NotClaimed]: {
        btnText: '免费领取',
        buttonType: 'primary',
        isDisable: false
    },
    [CouponStatus.CanInflate]: {
        btnText: '免费膨胀',
        buttonType: 'primary',
        isDisable: false
    },
    [CouponStatus.AfterInflate]: {
        btnText: '去使用',
        buttonType: 'plain',
        isDisable: false
    }
};
export const lxBidConfig = {
    componentMV: 'b_daodian_lowcode_0mjlssmu_mv',
    couponMV: 'b_daodian_lowcode_jmta9p78_mv',
    couponMC: 'b_daodian_lowcode_jmta9p78_mc'
};
export const lxCouponStatusReportMap = {
    [CouponStatus.NotStart]: 1,
    [CouponStatus.SoldOut]: 2,
    [CouponStatus.Claimed]: 4,
    [CouponStatus.Used]: 7,
    [CouponStatus.ToUse]: 4,
    [CouponStatus.NotClaimed]: 3,
    [CouponStatus.CanInflate]: 5,
    [CouponStatus.AfterInflate]: 6
};
export const lxBuIdMap = {
    [ENibBiz.FOOD_GROUP]: '1',
    [ENibBiz.DAO_ZONG_FAMILY_SERVICE]: '2',
    [ENibBiz.DAO_ZONG_XIU_YU]: '2',
    [ENibBiz.DAO_ZONG_BEAUTY_HEALTH]: '2',
    [ENibBiz.TRIP_OR_TRANSPORT]: '5',
    [ENibBiz.HOTEL]: '4'
};
// 有生效时间的状态
export const hasValidStateStatusList = [CouponStatus.ToUse, CouponStatus.Claimed, CouponStatus.AfterInflate, CouponStatus.CanInflate];
export const buttonStyle = {
    btnSize: {
        big: {
            height: '60rpx',
            width: '160rpx',
            borderRadius: '64rpx'
        },
        small: {
            height: '48rpx',
            width: '144rpx',
            borderRadius: '44rpx'
        }
    },
    btnSizeNumber: {
        big: {
            height: _toPx(60),
            width: _toPx(160)
        },
        small: {
            height: _toPx(48),
            width: _toPx(144)
        }
    }
};
